import * as ATypes from '../../shared/actionTypes';

export const paymentReducer = (state, action) => {
  const defaultState = {
    loading: false,
    paymentDetails: null,
    error: null,
  };

  if (!state) {
    state = defaultState;
  }

  switch (action.type) {
    case ATypes.GET_PAYMENT_DETAILS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case ATypes.GET_PAYMENT_DETAILS_SUCCESS:
      return {
        ...state,
        paymentDetails: action.payload,
      };
    case ATypes.GET_PAYMENT_DETAILS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case ATypes.PREPARE_PAYMENT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case ATypes.PREPARE_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentDetails: {
          ...state.paymentDetails,
          ...action.payload,
        },
      };
    case ATypes.PREPARE_PAYMENT_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case ATypes.MAKE_PAYMENT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case ATypes.MAKE_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentDetails: {
          ...state.paymentDetails,
          uri: action.payload.uri,
        },
      };

    case ATypes.MAKE_PAYMENT_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};
